import { EventDrivenStore } from '@core/store/eventDrivenStore';
import { EVENTS, DEFAULT_STATE } from './constants';

class SearchFiltersStore extends EventDrivenStore {
  constructor() {
    console.log('[SearchFiltersStore] Initializing SearchFiltersStore');
    super('searchFilters', DEFAULT_STATE);

    // setupEvents() is called automatically by EventDrivenStore constructor
    console.log('[SearchFiltersStore] SearchFiltersStore initialized successfully');
  }

  setupEvents() {
    console.log('[SearchFiltersStore] Setting up event listeners');

    this.on(EVENTS.SEARCH_FILTERS.SORT_UPDATED, (sortOption) => {
      console.log('[SearchFiltersStore] SORT_UPDATED event received:', sortOption);

      this.state.selectedSort = sortOption;
      this.updateFilters();
      console.log('[SearchFiltersStore] Sort option updated:', {
        sortOption,
        currentFilters: this.state.filters
      });
    });

    this.on(EVENTS.SEARCH_FILTERS.PRICE_UPDATED, (priceRangeId) => {
      console.log('[SearchFiltersStore] PRICE_UPDATED event received:', priceRangeId);

      this.state.selectedPriceRange = priceRangeId;
      this.updateFilters();
      console.log('[SearchFiltersStore] Price range updated:', {
        priceRangeId,
        currentFilters: this.state.filters
      });
    });

    this.on(EVENTS.SEARCH_FILTERS.CATEGORY_TOGGLED, (category) => {
      console.log('[SearchFiltersStore] CATEGORY_TOGGLED event received:', category);

      // Support both category object (with id property) and category id (string)
      const categoryId = typeof category === 'object' ? category?.id : category;
      if (!categoryId) {
        console.warn('[SearchFiltersStore] Invalid category:', category);
        return;
      }

      const index = this.state.selectedCategories.findIndex(cat => cat.id === categoryId);
      if (index > -1) {
        this.state.selectedCategories.splice(index, 1);
      } else {
        // If category is an object, store it; otherwise create a minimal object
        const categoryObj = typeof category === 'object' ? category : { id: category };
        this.state.selectedCategories.push(categoryObj);
      }
      this.updateFilters();
      console.log('[SearchFiltersStore] Categories toggled:', {
        categoryId,
        selectedCategories: this.state.selectedCategories,
        currentFilters: this.state.filters
      });
    });

    this.on(EVENTS.SEARCH_FILTERS.RESET_FILTERS, () => {
      console.log('[SearchFiltersStore] Reset filters event received');
      this.resetFilters();
    });

    this.on(EVENTS.SEARCH_FILTERS.SET_ALL_FILTERS, (filters) => {
      console.log('[SearchFiltersStore] Set all filters event received:', filters);
      this.setAllFilters(filters);
    });

    console.log('[SearchFiltersStore] All event listeners set up successfully');
  }

  updateFilters() {
    console.log('[SearchFiltersStore] Updating filters');

    // Extract category IDs from category objects for the filters
    const categoryIds = this.state.selectedCategories.map(cat =>
      typeof cat === 'object' ? cat.id : cat
    );

    this.state.filters = {
      sort: this.state.selectedSort,
      priceRange: this.state.selectedPriceRange,
      categories: categoryIds,
      hasActiveFilters: this.hasActiveFilters
    };

    this.emit(EVENTS.SEARCH_FILTERS.FILTERS_UPDATED, this.state.filters);
    console.log('[SearchFiltersStore] Filters updated and emitted:', this.state.filters);
  }

  get hasActiveFilters() {
    return !!(
      this.state.selectedSort ||
      this.state.selectedPriceRange ||
      (this.state.selectedCategories && this.state.selectedCategories.length > 0)
    );
  }

  getSelectedSort() {
    return this.state.selectedSort;
  }

  getSelectedPriceRange() {
    return this.state.selectedPriceRange;
  }

  getSelectedCategories() {
    return this.state.selectedCategories;
  }

  getActiveFilters() {
    return this.state.filters;
  }

  resetFilters() {
    console.log('[SearchFiltersStore] Resetting filters');
    this.state.selectedSort = null;
    this.state.selectedPriceRange = null;
    this.state.selectedCategories = [];
    this.updateFilters();
  }

  setAllFilters(filters) {
    console.log('[SearchFiltersStore] Setting all filters:', filters);
    if (filters.sort !== undefined) {
      this.state.selectedSort = filters.sort;
    }
    if (filters.priceRange !== undefined) {
      this.state.selectedPriceRange = filters.priceRange;
    }
    if (filters.categories !== undefined) {
      // Convert category IDs to category objects
      this.state.selectedCategories = filters.categories.map(cat => {
        if (typeof cat === 'object') {
          return cat;
        }
        return { id: cat };
      });
    }
    this.updateFilters();
    console.log('[SearchFiltersStore] All filters set:', {
      sort: this.state.selectedSort,
      priceRange: this.state.selectedPriceRange,
      categories: this.state.selectedCategories,
      filters: this.state.filters
    });
  }
}

export default SearchFiltersStore;
